// Libs
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
// App

/**
 * Interface definition for state
 */
interface State {
  loaded: boolean;
}

/**
 * Type definition for state
 */
export type ReduxPersistState = Readonly<State>;

/**
 * Initial state definition
 */
const initialState: State = {
  loaded: false,
};

/**
 * Reducer definition
 */
const reducers = {
  setPersistedDataLoaded: (state: State) => {
    state.loaded = true;
  },
};

/**
 * Slice definition
 */
const reduxPersistSlice = createSlice({
  name: 'reduxPersist',
  initialState,
  reducers,
});

/**
 * Extract isPersistedDataLoaded variable
 *
 * @param   {Object} state The root state
 * @returns {boolean} true if persisted data is loaded
 */
export const selectIsPersistedDataLoaded = (state: Readonly<RootState>): boolean => state.reduxPersist.loaded;

/**
 * Actions definition
 */
export const { setPersistedDataLoaded } = reduxPersistSlice.actions;

export default reduxPersistSlice.reducer;
